import styled from '@emotion/styled'

export const StudentContentContainer = styled.div`
  box-shadow: 0 10px 20px rgba(18, 38, 63, 0.03);
  @media (max-width: 1770px) {
  }
`
